import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("Transcribe")
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, { to: "/upload" }, {
            default: _withCtx(() => [
              _createTextVNode("Upload")
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, {
            to: "/signin",
            onClick: _ctx.signOut
          }, {
            default: _withCtx(() => [
              _createTextVNode("Signout")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}